import { render, staticRenderFns } from "./add-partner-doctor.vue?vue&type=template&id=6721bc2b&"
import script from "./add-partner-doctor.vue?vue&type=script&lang=js&"
export * from "./add-partner-doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports